import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import CropperImage from './CropperImage';
// import { ReactComponent as AppleIcon } from '../../assets/svg/apple.svg';
// import { ReactComponent as AndroidIcon } from '../../assets/svg/android.svg';
import MarkerEditor from 'comman/component/markerEditor.component';
import PreviewDevice from 'comman/component/PreviewDevice';

function blobToBase64(blob) {
  return new Promise((resolve, _) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
}

export const ImageEditorModal = ({
  // showImageEditor,
  // setShowImageEditor,
  // imageHandleClose,

  // setPreviewScreen,
  // previewScreen,

  // saveImageToGallery = false,
  isSaveAsNew,
  galleryObject,
  isOpenModal = false,
  defaultTab = 1,
  title = 'Image Editing',
  type = 'fullscreen',
  imageUrl = '',
  onHide,
  previewData,
  onChange,
  imageName,
  isOneTap
}) => {
  const [tab, setTab] = useState(defaultTab || 1);
  const [blobURL, setBlobURL] = useState({
    current: imageUrl,
    next: imageUrl,
    previous: imageUrl,
  });

  const [showMobile, setShowMobile] = useState('ios');
  const [showIosDeviceType, setShowIosDeviceType] = useState('old');
  const [markerState, setMarkerState] = useState();
  const [blobData, setBlobData] = useState();
  const changeMobile = (modelName) => {
    setShowMobile(modelName);
  };

  const [isAsNew, setIsAsNew] = useState(false);

  const handleImageSave = () => {
    onChange({
      preview: blobURL.next,
      name: imageName,
      isAsNew,
      // file: new File([blobURL.next], 'edit-file'),
    });
    // setTab(1);
    // setShowImageEditor(false);
    // setPreviewScreen((prevState) => ({
    //   ...prevState,
    //   image: blobData,
    //   isAsNew: isAsNew,
    // }));
    // saveImageToGallery && saveImageToGallery(isAsNew);
    setIsAsNew(false);
    handleClose();
  };

  function handleClose() {
    setTab(1);
    onHide();
  }

  async function changeToBase64(url) {
    if (!url?.startsWith?.('blob:')) {
      const urlFromGallery = galleryObject?.[url];
      if (urlFromGallery) {
        setBlobURL({
          current: urlFromGallery,
          next: urlFromGallery,
          previous: urlFromGallery,
        });
      } else {
        const resImg = await fetch(url)
          .then((value) => value.blob())
          .then((value) => blobToBase64(value));
        setBlobURL({
          current: resImg,
          next: resImg,
          previous: resImg,
        });
      }
    } else {
      setBlobURL({
        current: url,
        next: url,
        previous: url,
      });
    }
  }

  useEffect(() => {
    if (imageUrl) {
      changeToBase64(imageUrl);
    }
  }, [imageUrl]);

  return (
    <>
      <Modal
        size='lg'
        show={isOpenModal}
        onHide={handleClose}
        className='photo-edit-modal'
        backdrop='static'>
        <Modal.Header closeButton>
          <Modal.Title>
            <h2>{title}</h2>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ zIndex: 10000 }}>
            {tab && tab === 1 && (
              <CropperImage
                path={blobURL.current}
                type={type}
                onCancel={handleClose}
                onNext={(value) => {
                  setBlobURL((prevState) => ({
                    ...prevState,
                    next: value,
                  }));
                  setTab(2);
                }}
                isOneTap={isOneTap}
                // setBlobURL={setBlobURL}
                // blobURL={blobURL}
                // setShowImageEditor={setShowImageEditor}
                // setPreviewScreen={setPreviewScreen}
                // setTab={setTab}
                // imageEditData={imageEditData}
                // setImageEditData={setImageEditData}
                // setMarkerState={setMarkerState}
              />
            )}
            {tab && tab === 2 && (
              <MarkerEditor
                path={blobURL.next}
                setBlobURL={setBlobURL}
                blobURL={blobURL}
                setTab={setTab}
                setBlobData={setBlobData}
                setMarkerState={setMarkerState}
                markerState={markerState}
                isSaveAsNew={isSaveAsNew}
                setIsAsNew={setIsAsNew}
              />
            )}
            {tab && tab === 3 && (
              <div className='col-12 col-lg-12 col-md-12 col-sm-12'>
                <PreviewDevice
                  type={type}
                  previewScreen={previewData}
                  // fullscreenUrl={blobURL.next}
                  fullscreenUrl={
                    type === 'fullscreen'
                      ? blobURL.next
                      : previewData?.currentGallery
                  }
                  logoUrl={
                    type === 'logo'
                      ? blobURL.next
                      : previewData?.currentGalleryCircle
                  }
                />
                <div className='img-editing-action-btn'>
                  <button
                    className='btn btn-primary'
                    onClick={(e) => {
                      setTab(2);
                      setBlobURL({
                        ...blobURL,
                        next: blobURL.current,
                      });
                    }}>
                    Back
                  </button>
                  <button className='btn btn-primary' onClick={handleImageSave}>
                    Save
                  </button>
                </div>
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ImageEditorModal;
